/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { init } from '@sentry/angular';
import { environment } from '@shared/environments/environment';

/**
 * Sentry.io init for unhandled error capturing
 */
if (environment.context === 'production') {
  init({
    dsn: environment.sentry,
  });
}

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
